"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupByToMultimap = void 0;
/**
 * Creates an {@link IMultimap<K, V>} using the values in {@link GroupByToMultimapParams} to convert the data
 * into a map where the key is transformed into {@link K} by the keyTransform function and the value
 * is a {@link ReadonlyArray} of {@link V} transformed by the valTransform function.
 *
 * @param {ReadonlyArray<T>} data - the array of data to be converted into a multimap
 * @param {(value: T) => K} keyTransform - the function that will convert an item in data into a key of type {@link K}
 * @param {(value: T) => V} valTransform - the function that will convert an item in data into a value of type {@link V}
 * @param {(key: K) => string} keyBy - the function that will convert a key into a string due to the constraints of JavaScript's {@link Map} implementation,
 * for more details see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#a_model_for_understanding_equality_comparisons
 *
 * @returns an {@link IMultimap<K, V>}
 */
function groupByToMultimap(_a) {
    var data = _a.data, keyTransform = _a.keyTransform, valTransform = _a.valTransform, keyBy = _a.keyBy;
    var map = data.reduce(function (acc, val, _, __, key) {
        if (key === void 0) { key = keyTransform(val); }
        return (getOrPut(acc, keyBy(key), function () { return ([]); }).push(valTransform(val)), acc);
    }, new Map());
    return new Multimap(map, keyBy);
}
exports.groupByToMultimap = groupByToMultimap;
var Multimap = /** @class */ (function () {
    function Multimap(map, keyBy) {
        this.map = map;
        this.keyBy = keyBy;
    }
    Multimap.prototype.get = function (key) {
        var transformed = this.keyBy(key);
        return this.map.get(transformed);
    };
    return Multimap;
}());
function getOrPut(map, key, defaultValue) {
    var value = map.get(key);
    if (value === undefined) {
        var def = defaultValue();
        map.set(key, def);
        return def;
    }
    else {
        return value;
    }
}
//# sourceMappingURL=GroupByToMultimap.js.map